import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form, Row, Col, Button, InputGroup, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { BsCalendar, BsClockHistory, BsPaperclip, BsChatText } from 'react-icons/bs';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import "react-datepicker/dist/react-datepicker.css";
import '../styles/main.css';
import { apiGet, apiPost } from '../services/api';
import { useToast } from '../hooks/useToast';
import { format } from 'date-fns';
import DeadlineHistoryModal from '../components/modals/DeadlineHistoryModal';
import AttachmentsModal from '../components/modals/AttachmentsModal';
import CommentsModal from '../components/modals/CommentsModal';
import { toast } from 'react-toastify';

const TaskDetailForm = () => {
  const [hasSearched, setHasSearched] = useState(false);
  const decisionFromRef = useRef(null);
  const decisionToRef = useRef(null);
  const deadlineFromRef = useRef(null);
  const deadlineToRef = useRef(null);
const user = JSON.parse(sessionStorage.getItem("user"));
const roleName = user?.roleName?.toLowerCase(); 
const isRestrictedUser = roleName === "taskcoordinator" || roleName === "viewer"; 
const isAdmin = roleName === "admin";
  const [decisionFrom, setDecisionFrom] = useState(null);
  const [decisionTo, setDecisionTo] = useState(null);
  const [deadlineFrom, setDeadlineFrom] = useState(null);
  const [deadlineTo, setDeadlineTo] = useState(null);

  const [categories, setCategories] = useState([]);
  const [taskCoordinators, setTaskCoordinators] = useState([]);
  const [groups, setGroups] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [priorities, setPriorities] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const { showToast } = useToast();

  const [expandedRows, setExpandedRows] = useState({});

const toggleExpand = (rowId, columnKey) => {
  const key = columnKey ? `${rowId}-${columnKey}` : rowId;
  setExpandedRows(prev => ({
    ...prev,
    [key]: !prev[key]
  }));
};


  const [filters, setFilters] = useState({
    taskId: null,
    issueActionOrDecision: '',
    group: null,
    taskCoordinator: null,
    followedBy: null,
    officerResponsible: null,
    priority: null,
    status: null,
    category: null,
    attachmentsOnly: false,
  });

  const [deadlineHistoryModal, setDeadlineHistoryModal] = useState({
    visible: false,
    loading: false,
    deadlines: [],
    currentTaskId: null
  });

  const [attachmentsModal, setAttachmentsModal] = useState({
    show: false,
    taskId: null,
    officerNames: '',
    attachments: [],
    onFileDelete: () => { }
  });

  const [commentsModal, setCommentsModal] = useState({
    show: false,
    taskId: null,
    officerNames: '',
    comments: [],
    existingComments: ''
  });

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'dd/MM/yyyy');
    } catch {
      return 'Invalid Date';
    }
  };

      const handleShowActionHistoryComments = async (task) => {
    try {
      let actionHistory = [];
      
      if (task.actionStatusHistory) {
        try {
          actionHistory = JSON.parse(task.actionStatusHistory);
        } catch (err) {
          console.error("Error parsing actionStatusHistory:", err);

          if (task.actionTakenOrStatus && task.actionTakenOrStatus !== 'N/A') {
            actionHistory = [{
              commentText: task.actionTakenOrStatus,
              createdDate: task.latestActionCommentDate || new Date().toISOString(),
              createdByName: task.coordinatorNames || 'Coordinator'
            }];
          }
        }
      }

      setCommentsModal({
        show: true,
        taskId: task.taskID,
        officerNames: task.coordinatorNames || 'Coordinator',
        comments: Array.isArray(actionHistory) ? actionHistory : [],
        existingComments: task.actionTakenOrStatus || 'No action history available',
        type: 'action-history'
      });

    } catch (error) {
      console.error('Error loading action history comments:', error);
      toast.error('Could not load action history comments');

      setCommentsModal({
        show: true,
        taskId: task.taskID,
        officerNames: task.coordinatorNames || 'Coordinator',
        comments: [],
        existingComments: task.actionTakenOrStatus || 'No action history available',
        type: 'action-history'
      });
    }
  };

  const handleShowDeadlineHistory = async (taskId) => {
    debugger
    try {
      setDeadlineHistoryModal((prev) => ({
        ...prev,
        visible: true,
        loading: true,
        currentTaskId: taskId,
      }));

      const response = await apiGet(`/TaskTracking/task-deadlines/${taskId}`);

      if (response?.isSuccess && response.data) {
        const sortedDeadlines = response.data.sort(
          (a, b) => new Date(b.changeDate) - new Date(a.changeDate)
        );

        setDeadlineHistoryModal((prev) => ({
          ...prev,
          deadlines: sortedDeadlines,
          loading: false,
        }));
      } else {
        setDeadlineHistoryModal((prev) => ({ ...prev, loading: false }));
        toast.error(response?.message || "No deadline history found");
      }
    } catch (error) {
      console.error("Error fetching deadline history:", error);
      setDeadlineHistoryModal((prev) => ({ ...prev, loading: false }));
      toast.error("Failed to load deadline history");
    }
  };

  const handleShowAttachments = async (task) => {
    setAttachmentsModal({
      show: true,
      taskId: task.taskID,
      officerNames: task.officerNames || 'Officer',
      attachments: task.taskAttachments || [],
      onFileDelete: () => {
        handleSearch();
      }
    });
  };

  const handleShowOfficerComments = async (task) => {
    try {
      const endpointsToTry = [
        `/Task/GetTaskComments?taskId=${task.taskID}`,
        `/api/TaskComments/${task.taskID}`,
        `/TaskComments/GetByTaskId/${task.taskID}`
      ];

      let response;

      for (const endpoint of endpointsToTry) {
        try {
          response = await apiGet(endpoint);
          if (response) break;
        } catch (err) {
          console.log(`Failed to fetch from ${endpoint}`, err);
        }
      }

      const comments = response?.data || [];

      setCommentsModal({
        show: true,
        taskId: task.taskID,
        officerNames: task.officerNames || 'Officer',
        comments: Array.isArray(comments) ? comments : [],
        existingComments: task.additionalComments || 'No comments available'
      });

    } catch (error) {
      console.error('Error loading comments:', error);
      toast.error('Could not load comments');

      setCommentsModal({
        show: true,
        taskId: task.taskID,
        officerNames: task.officerNames || 'Officer',
        comments: [],
        existingComments: task.additionalComments || 'No comments available'
      });
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setIsLoading(true);
        const [usersRes, prioritiesRes, categoriesRes, groupsRes, statusesRes] = await Promise.all([
          apiGet('/User/GetAllUsers'),
          apiGet('/User/GetAllPriority'),
          apiGet('/User/GetAllCategories'),
          apiGet('/Group/GetAll'),
          apiGet('/User/GetAllStatus')
        ]);

        if (usersRes?.isSuccess) {
          setAllUsers(usersRes.data || []);
          const coordinators = usersRes.data
            .filter(user => user.roleName?.toLowerCase() === 'taskcoordinator')
            .map(user => ({
              value: user.userID,
              label: user.username
            }));
          setTaskCoordinators(coordinators);
        }

        if (prioritiesRes?.isSuccess) setPriorities(prioritiesRes.data || []);
        if (categoriesRes?.isSuccess) setCategories(categoriesRes.data || []);
        if (groupsRes?.isSuccess) {
          setGroups(groupsRes.data.map(group => ({
            value: group.groupID,
            label: group.name
          })) || []);
        }
        if (statusesRes?.isSuccess) setStatuses(statusesRes.data || []);

         await handleSearch();
      } catch (error) {
        console.error('Error fetching data:', error);
        showToast('Failed to load initial data', 'error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, [showToast]);

  const priorityOptions = useMemo(() =>
    priorities.map(priority => ({
      value: priority.priorityID.toString(),
      label: priority.priorityName
    })),
    [priorities]
  );

  const statusOptions = useMemo(() =>
    statuses.map(status => ({
      value: status.statusID.toString(),
      label: status.statusName
    })),
    [statuses]
  );

const taskIdOptions = useMemo(() => {
  const uniqueTaskIds = [...new Set(tasks.map(task => task.taskID || task.taskId))];
  
  const sortedTaskIds = uniqueTaskIds.sort((a, b) => b - a);
  
  return sortedTaskIds.map(taskID => ({
    value: taskID,
    label: ` ${taskID}`
  }));
}, [tasks]);

  const categoryOptions = useMemo(() =>
    categories.map(category => ({
      value: category.categoryID,
      label: category.categoryName
    })),
    [categories]
  );

  const officerOptions = useMemo(() => {
    return allUsers
      .filter(user =>
        user.roleName?.toLowerCase() === 'taskcoordinator' &&
        (!filters.taskCoordinator || user.userID !== filters.taskCoordinator.value)
      )
      .map(user => ({
        value: user.userID,
        label: user.username,
      }));
  }, [allUsers, filters.taskCoordinator]);

  const handleSelectChange = (name, selectedOption) => {
    setFilters(prev => ({
      ...prev,
      [name]: selectedOption
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFollowedByChange = (selectedOption) => {
    setFilters(prev => ({
      ...prev,
      followedBy: selectedOption
    }));
  };

  const handleSearch = async () => {
    setIsLoading(true);
    setHasSearched(true);
    try {
       debugger
      const payload = {
       
        TaskID: filters.taskId?.value || null,
        IssueActionorDecision: filters.issueActionOrDecision || null,
        GroupID: filters.group?.value || null,
        TaskCoordinatorID: filters.taskCoordinator?.value || null,
        OfficerResponsible: filters.officerResponsible?.value || null,
        Priority: filters.priority?.value || null,
        Status: filters.status?.value || null,
        Category: filters.category?.value || null,
        StartDate: decisionFrom ? format(decisionFrom, 'yyyy-MM-dd') : null,
        EndDate: decisionTo ? format(decisionTo, 'yyyy-MM-dd') : null,
        DeadlineStartDate: deadlineFrom ? format(deadlineFrom, 'yyyy-MM-dd') : null,
        DeadlineEndDate: deadlineTo ? format(deadlineTo, 'yyyy-MM-dd') : null,
        followedBy: filters.followedBy?.value || null,
      };

      const res = await apiPost('/auth/GetTaskDetail', payload);

      if (Array.isArray(res)) {
        let filteredTasks = res;

        if (filters.attachmentsOnly) {
          filteredTasks = res.filter(task =>
            task.taskAttachments && typeof task.taskAttachments === 'string' && task.taskAttachments.trim().length > 0
          );
        }

        const formattedTasks = filteredTasks.map(task => {
          let status = 'Work in Progress';
          const deadline = task.deadline ? new Date(task.deadline) : null;
          const today = new Date();

  if (task.actionTakenOrStatus === 'Completed') {
    status = 'Completed'
          } else if (deadline) {
            const diffDays = Math.floor((today - deadline) / (1000 * 60 * 60 * 24));

            if (diffDays > 0) {
              if (diffDays <= 7) {
                status = 'On Time';
              } else if (diffDays <= 30) {
                status = 'Slight Delay';
              } else {
                status = 'Significant Delay';
              }
            }
          }

          return {
            ...task,
            status,
            taskId: task.taskID,
            issueActionOrDecision: task.issueActionOrDecision || 'N/A',
            priorityName: task.priorityName || 'N/A',
            dateOfDecisionOrInitiation: task.dateOfDecisionOrInitiation,
            deadline: task.deadline,
            coordinatorNames: task.coordinatorNames || 'N/A',
            // officerNames: task.officerNames || 'N/A',

            officerNames: task.officerNames || task.officerResponsible || task.responsibleOfficer || task.officerName || 'N/A',
            categoryName: task.categoryName || 'N/A',
            actionTakenOrStatus: task.actionTakenOrStatus || 'N/A',
            additionalComments: task.additionalComments || 'N/A',
            taskAttachments: task.taskAttachments
              ? task.taskAttachments.split(',')
              : []
          };
        });

        const sortedTasks = formattedTasks.sort((a, b) => {
          const statusPriority = {
            'Significant Delay': 1,
            'Slight Delay': 2,
            'On Time': 3,
            'Work in Progress': 4,
            'Completed': 5
          };

          if (statusPriority[a.status] !== statusPriority[b.status]) {
            return statusPriority[a.status] - statusPriority[b.status];
          }
          return new Date(b.createdDate) - new Date(a.createdDate);
        });

        setTasks(sortedTasks);
      } else {
        console.error('No data found or invalid response format');
        setTasks([]);
      }
    } catch (err) {
      console.error('Error fetching task details:', err);
      showToast('Failed to fetch task details', 'error');
      setTasks([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = async () => {

    setFilters({
      taskId: null,
      issueActionOrDecision: '',
      group: null,
      taskCoordinator: null,
      followedBy: null, 
      officerResponsible: null,
      priority: null,
      status: null,
      category: null,
      attachmentsOnly: false, 
    });
    setDecisionFrom(null);
    setDecisionTo(null);
    setDeadlineFrom(null);
    setDeadlineTo(null);
    
    try {
      setIsLoading(true);
      const res = await apiPost('/auth/GetTaskDetail', {});
      if (Array.isArray(res)) {
        setTasks(res);
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
      showToast('Failed to reload tasks', 'error');
    } finally {
      setIsLoading(false);
    }
};

//<---Export to Excel-->
  const handleExportToExcel = () => {
    if (tasks.length === 0) {
      toast.warning('No data to export');
      return;
    }

 
    const exportData = tasks.map(task => ({
      'Task ID': task.taskID || task.taskId,
      'Issue, Action or Decision': task.issueActionOrDecision,
      'Priority': task.priorityName,
      'Date of Decision': formatDate(task.dateOfDecisionOrInitiation),
      'Deadline': formatDate(task.deadline),
      'Actual Completion Date': formatDate(task.actualCompletionDate),
      'Task Coordinator': task.coordinatorNames,
      'Action Taken / Status': task.actionTakenOrStatus,
      'Officer Responsible': task.officerNames,
      'Additional Comments': task.additionalComments,
    }));

 
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    
 
    XLSX.utils.book_append_sheet(wb, ws, "Task Details");
    
  
    const fileName = `Task_Details_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };
//<---Export to Excel-->

  const columns = [
    {
      name: 'Task ID',
      selector: row => row.taskID || row.taskId,
      sortable: true,
       width: '130px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
  {
    name: <div style={{textAlign:'center'}}>Issue, Action or Decision</div>,
    cell: row => {
      const text = row.issueActionOrDecision || '';
      const isExpanded = expandedRows[row.taskID];
      const shortText = text.length > 100 ? text.slice(0, 100) + '...' : text;

      return (
        <div style={{ minWidth: '200px', whiteSpace: 'pre-wrap', textAlign:"left" }}>
          {isExpanded ? text : shortText}
          {text.length > 100 && (
            <span
              onClick={() => toggleExpand(row.taskID)}
              style={{ color: ' #176B87', cursor: 'pointer',whiteSpace:'nowrap', marginLeft: '5px' }}
            >
              {isExpanded ? 'View Less' : 'View More'}
            </span>
          )}
        </div>
      );
    },
    sortable: true,
    wrap: true,
     width: '260px',
    
   style: {
      borderRight: '1px solid #dee2e6',
    },
  },
    {
      name: 'Priority',
     
      selector: row => row.priorityName,
       cell: (row) => {
        let bg = "transparent", color = "#1e293b";

        switch (row.priorityName?.toLowerCase()) {
          case "top":
            color = "#92400e"; break; // Yellow
          case "high":
            color = "#7f1d1d"; break; // Red
          case "medium":
             color = "#1e3a8a"; break; // Blue
        }

        return (
          <span
            style={{
              display: "inline-block",
              padding: "4px 12px",
              borderRadius: "999px",
              backgroundColor: bg,
              color: color,
              fontWeight: "600",
              fontSize: "13px",
              textTransform: "capitalize",
            }}
          >
            {row.priorityName}
          </span>
        );
      },
      sortable: true,
        width: '120px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: 'Date of Decision',
      cell: row => formatDate(row.dateOfDecisionOrInitiation),
      sortable: true,
      width: '190px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
  name: "Deadline",
  selector: (row) => formatDate(row.deadline),
  cell: (row) => {
    const hasDeadlineHistory = row.allDeadline !== null && row.allDeadline.length > 0;
    
    return (
      <div className="d-flex align-items-center">
        <span>{formatDate(row.deadline)}</span>
        {hasDeadlineHistory && (
          <i
            className="bi bi-clock-history ms-2 text-muted cursor-pointer mediumcolor"
            onClick={(e) => {
              e.stopPropagation();
              handleShowDeadlineHistory(row.taskID);
            }}
            title="View deadline history"
           
          />
        )}
      </div>
    );
  },
      sortable: true,
       width: '150px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: 'Task Coordinator',
      selector: row => row.coordinatorNames || 'N/A',
      sortable: true,
        width: '210px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
{
      name: <div  style={{textAlign:'center'}}>Action Taken / Status</div>,
      cell: row => {
        const text = row.actionTakenOrStatus || 'N/A';
        const key = `${row.taskID}-status`;
        const isExpanded = expandedRows[key];
        const shortText = text.length > 100 ? text.slice(0, 100) + '...' : text;

        const hasActionHistory = row.actionStatusHistory && row.actionStatusHistory.length > 0;

        return (
          <div style={{ minWidth: '200px', whiteSpace: 'pre-wrap' }}>
            {isExpanded ? text : shortText}
            {text.length > 100 && (
              <span
                onClick={() => toggleExpand(row.taskID, 'status')}
                style={{ color: ' #176B87', cursor: 'pointer', whiteSpace:'nowrap' , marginLeft: '5px' }}
              >
                {isExpanded ? 'View Less' : 'View More'}
              </span>
            )}
            
            {hasActionHistory && (
              <BsChatText
                className="ms-2 text-muted cursor-pointer mediumcolor"
                onClick={(e) => {
                  e.stopPropagation();
                  handleShowActionHistoryComments(row);
                }}
                title="View action history comments"
              />
            )}
          </div>
        );
      },
      wrap: true,
      width: '250px',
      center: true,
      style: {
        borderRight: '1px solid #dee2e6',
           textAlign:'left'
      },
    },
  {
    name: <div  style={{textAlign:'center'}}>Officer Responsible</div>,
    cell: row => {
      const hasAttachments = row.taskAttachments && row.taskAttachments.length > 0;
      
      return (
        <div className="d-flex align-items-center">
          <span>{row.officerNames || 'N/A'}</span>
          
          {hasAttachments && (
            <BsPaperclip
              className="ms-2 text-muted cursor-pointer mediumcolor"
              onClick={(e) => {
                e.stopPropagation();
                handleShowAttachments(row);
              }}
              title="View attachments"
            />
          )}
        </div>
      );
    },
    wrap: true,
    width: '200px',
    center: true,
    style: {
      borderRight: '1px solid #dee2e6',
        textAlign:'left'
    },
  },
  {
    name: <div  style={{textAlign:'center'}}>Additional Comments</div> ,
    cell: row => {
      const text = row.additionalComments || 'N/A';
      const key = `${row.taskID}-additional`;
      const isExpanded = expandedRows[key];
      const shortText = text.length > 100 ? text.slice(0, 100) + '...' : text;
      
      // Check if there are comments to show
      const hasComments = (row.additionalComments && row.additionalComments !== 'N/A') || 
                         (row.officerComments && row.officerComments !== 'N/A');

      return (
        <div style={{ minWidth: '200px', whiteSpace: 'pre-wrap' }}>
          {isExpanded ? text : shortText}
          {text.length > 100 && (
            <span
              onClick={() => toggleExpand(row.taskID, 'additional')}
              style={{ color: ' #176B87', cursor: 'pointer', whiteSpace:'nowrap', marginLeft: '5px' }}
            >
              {isExpanded ? 'View Less' : 'View More'}
            </span>
          )}
          
          {/* Show comment icon here if there are comments */}
          {hasComments && (
            <BsChatText
              className="ms-2 text-muted cursor-pointer mediumcolor"
              onClick={(e) => {
                e.stopPropagation();
                handleShowOfficerComments(row);
              }}
              title="View comments"
            />
          )}
        </div>
      );
    },
    wrap: true,
    width: '250px',
    
    style: {
      borderRight: '1px solid #dee2e6',
      textAlign:'left'
    },
  }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#2c3e50',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
        '&:hover': {
          backgroundColor: '#f8f9fa',
        }
      },
    },
    cells: {
      style: {
        paddingTop: '8px',
        paddingBottom: '8px',
        wordBreak: 'break-word'
      }
    }
  };


   // <--Report  -->

const openReport = () => {
  console.log("openReport called");
  console.log("tasks from API:", tasks); 

  if (tasks.length === 0) {
    toast.warning("No tasks to generate report");
    return;
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatValue = (value) => value && value !== 'N/A' ? value : '';

  const groupedTasks = tasks.reduce((acc, task) => {
    const key = `${task.coordinatorNames || ''}|${task.priorityName || ''}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(task);
    return acc;
  }, {});

  const currentDate = new Date();
  let serialCounter = 1; 

  const sections = Object.entries(groupedTasks).map(([key, groupTasks]) => {
    const [coordinator, priority] = key.split('|');

    const tasksHtml = groupTasks.map((task) => {
      const currentSerial = serialCounter++; 

      const hasAttachments = task.taskAttachments && task.taskAttachments.length > 0;
      const attachmentIcon = hasAttachments ? '<i class="fas fa-paperclip attachment-icon"></i>' : '';

      let commentsHtml = '';
      if (task.actionTakenOrStatus && task.actionTakenOrStatus !== 'N/A') {
        commentsHtml = `
          <div class="comments-section">
            <strong style="color: red;">Task Coordinator (Last Updated: ${formatDate(task.latestActionCommentDate) || 'N/A'})</strong><br>
            ${task.actionTakenOrStatus}
          </div>
        `;
      }

      let officerUpdatesHtml = '';
      if (task.officerComments && task.officerComments !== 'N/A') {
        const commentsArray = task.officerComments
          .split(',')
          .map(comment => comment.trim())
          .filter(comment => comment !== '');

        const commentDates = Array.isArray(task.officerCommentDates)
          ? task.officerCommentDates
          : (typeof task.officerCommentDates === 'string' 
              ? task.officerCommentDates.split(',').map(date => date.trim()) 
              : []);

        officerUpdatesHtml = `
          ${commentsArray.map((comment, i) => {
            const separatorIndex = comment.indexOf(':');
            const officerName = separatorIndex !== -1 ? comment.substring(0, separatorIndex).trim() : 'Officer';
            const commentText = separatorIndex !== -1 ? comment.substring(separatorIndex + 1).trim() : comment;
            const commentDate = formatDate(commentDates[i]) || 'N/A';

            return `
<div class="officer-update">
  <strong style="color: dodgerblue;">
    Officer Responsible (Last Updated: ${formatDate(task.latestCommentDate) || 'N/A'})
  </strong><br>
  <strong>${officerName} : ${commentDate}</strong><br>
  <span>${commentText}</span>
</div>
            `;
          }).join('')}
        `;
      }

      // return `
      //   <tr>
      //     <td>${attachmentIcon} ${currentSerial}</td>
      //     <td>${formatValue(task.taskID)}</td>
      //     <td>${formatValue(task.issueActionOrDecision)}</td>
      //     <td>${formatValue(task.officerNames || task.officerNames)}</td>
      //     <td>
      //       Date of decision/initiation: ${formatDate(task.dateOfDecisionOrInitiation) || ''}<br>
      //       Deadline: <br> ${
      //         task.allDeadline && task.allDeadline.includes(',')
      //           ? task.allDeadline
      //               .split(',')
      //               .map(d => d.trim())
      //               .reverse()
      //               .map(d => formatDate(d))
      //               .join('<br>')
      //           : (task.deadline ? formatDate(task.deadline) : '')
      //       }<br>
      //       <br>  <span class="status-completed">Status: ${formatValue(task.status)}</span><br>
      //     </td>
      //     <td>
      //       ${commentsHtml}
      //       ${officerUpdatesHtml}
      //     </td>
      //   </tr>
      // `;



return `
  <tr>
    <td>${attachmentIcon} ${currentSerial}</td>
    <td>${formatValue(task.taskID)}</td>
    <td>${formatValue(task.issueActionOrDecision)}</td>
    <td>${formatValue(task.officerNames || task.officerNames)}</td>
    <td>
      Date of decision/initiation: ${formatDate(task.dateOfDecisionOrInitiation) || ''}<br>
      Deadline: <br> ${
        task.deadline ? formatDate(task.deadline) + ' *' : ''
      }${
        task.allDeadline 
          ? '<br>' + 
            [...new Set(
              task.allDeadline
                .split(',')
                .map(d => d.trim())
                .filter(d => {
                  if (d === task.deadline) return false;
                  return formatDate(d) !== formatDate(task.deadline);
                })
                .reverse()
            )]
            .map(d => formatDate(d))
            .join('<br>')
          : ''
      }<br>
      <br><span class="status-completed">Status: ${formatValue(task.status)}</span><br>
    </td>
    <td>
      ${commentsHtml}
      ${officerUpdatesHtml}
    </td>
  </tr>
`;
    }).join('');



    

    return `
      <div class="section">
        <div class="info-row">
          <div class="task-coordinator">Task Coordinator: ${formatValue(coordinator)}</div>
          <div class="priority">Priority: ${formatValue(priority)}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width: 5%">S.r.No.</th>
              <th style="width: 8%">Task ID</th>
              <th style="width: 22%">Issue.Action or Decision</th>
              <th style="width: 15%">Officer Responsible</th>
              <th style="width: 20%">Timelines</th>
              <th style="width: 30%">Action Taken/Status</th>
            </tr>
          </thead>
          <tbody>
            ${tasksHtml}
          </tbody>
        </table>
      </div>
    `;
  }).join('');

  const formattedDate = format(currentDate, 'dd/MM/yyyy hh:mm:ss a');

  const reportContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>TaskTracking Dashboard Report</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
        <style>
          /* CSS styles here (no changes needed, already correct) */
          @page { size: A4; margin: 20mm; }
          body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
              line-height: 1.5;
              font-size: 11pt;
              color: #333;
              background-color: #fff;
          }
          .page-container { width: 80%; margin: 0 auto; padding: 10mm 0; box-sizing: border-box; }
          @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; background: white; }
              .page-container { width: 80%; padding: 0; margin: 0 auto; }
          }
          .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
          .title {
              width: 100%;
              text-align: center;
              font-size: 20pt;
              color: #2c3e50;
              font-weight: bold;
              margin: 5px 0 15px 0;
          }
          .report-date {
              font-size: 10pt;
              color: #555;
              text-align: right;
              margin-bottom: 15px;
          }
          .info-row { display: flex; justify-content: space-between; align-items: center; margin: 5px 0 10px 0; }
          .task-coordinator { font-size: 12pt; color: #2c3e50; }
          .priority { font-weight: bold; font-size: 11pt; color: #c0392b; }
          table {
              width: 100%;
              border-collapse: collapse;
              margin: 10px 0 20px 0;
              page-break-inside: avoid;
              font-size: 10pt;
          }
          th, td {
              border: 1px solid #ddd;
              padding: 6px 8px;
              text-align: left;
              vertical-align: top;
          }
          th {
              background-color: #f2f2f2;
              font-weight: bold;
          }
          .status-completed {
              color: #155724;
              background-color: #d4edda;
              padding: 2px 6px;
              border-radius: 3px;
              font-weight: bold;
              display: inline-block;
              font-size: 9pt;
          }
          .section {
              page-break-inside: avoid;
              margin-bottom: 25px;
          }
          .attachment-icon {
              color: #666;
              margin-right: 5px;
          }
          .comments-section, .officer-update {
              margin-top: 8px;
              font-size: 9pt;
              border-top: 1px dashed #ccc;
              padding-top: 8px;
          }
          .comments-section strong, .officer-update strong {
              color: #2c3e50;
          }
        </style>
    </head>
    <body>
      <div class="page-container">
        <div class="report-date">Date Time: ${formattedDate}</div>
        <div class="title">TaskTracking Dashboard Report</div>
        ${sections}
      </div>
    </body>
    </html>
  `;

  const reportWindow = window.open('', '_blank');
  reportWindow.document.open();
  reportWindow.document.write(reportContent);
  reportWindow.document.close();
};

//<--Report  -->




// Report With ALL Comments
const handleReportWithAllComments = () => {
  console.log("handleReportWithAllComments called");
  console.log("tasks from API:", tasks);
  
  if (tasks.length === 0) {
    toast.warning("No tasks to generate report");
    return;
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatValue = (value) => value && value !== 'N/A' ? value : '';

  const groupedTasks = tasks.reduce((acc, task) => {
    const key = `${task.coordinatorNames || ''}|${task.priorityName || ''}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(task);
    return acc;
  }, {});

  const currentDate = new Date();
  let serialCounter = 1;

  const sections = Object.entries(groupedTasks).map(([key, groupTasks]) => {
    const [coordinator, priority] = key.split('|');
    
    const tasksHtml = groupTasks.map((task) => {
      const currentSerial = serialCounter++;
      const hasAttachments = task.taskAttachments && task.taskAttachments.length > 0;
      const attachmentIcon = hasAttachments ? '<i class="fas fa-paperclip attachment-icon"></i>' : '';
      
      console.log(`Processing Task ${task.taskID}:`, {
        actionStatusHistory: task.actionStatusHistory,
        allOfficerComments: task.allOfficerComments,
        officerComments: task.officerComments,
        additionalComments: task.additionalComments
      });

      let actionStatusHistoryHtml = '';
      if (task.actionStatusHistory) {
        try {
          const actionHistory = JSON.parse(task.actionStatusHistory);
          if (Array.isArray(actionHistory) && actionHistory.length > 0) {
            actionStatusHistoryHtml = actionHistory.map(history => `
              <div class="action-history" style="margin-bottom: 12px;">
                <strong style="color: red;">Task Coordinator (Last Updated: ${formatDate(task.latestActionCommentDate) || 'N/A'})</strong><br>
                <strong>${history.createdByName || 'System'} : ${formatDateTime(history.createdDate)}</strong><br>
                <span>${history.commentText || ''}</span>
              </div>
            `).join('');
          }
        } catch (err) {
          console.error("Error parsing ActionStatusHistory for task", task.taskID, err);
          if (task.actionTakenOrStatus && task.actionTakenOrStatus !== 'N/A') {
            actionStatusHistoryHtml = `
              <div class="action-history" style="margin-bottom: 12px;">
                <strong style="color: red;">Task Coordinator (Last Updated: ${formatDate(task.latestActionCommentDate) || 'N/A'})</strong><br>
                <span>${task.actionTakenOrStatus}</span>
              </div>
            `;
          }
        }
      } else if (task.actionTakenOrStatus && task.actionTakenOrStatus !== 'N/A') {
        actionStatusHistoryHtml = `
          <div class="action-history" style="margin-bottom: 12px;">
            <strong style="color: red;">Task Coordinator (Last Updated: ${formatDate(task.latestActionCommentDate) || 'N/A'})</strong><br>
            <span>${task.actionTakenOrStatus}</span>
          </div>
        `;
      }

      let officerCommentsHtml = '';
      let processedOfficerComments = new Set();
      let latestAdditionalCommentBy = ''; 
      let latestAdditionalCommentDate = ''; 
      

      if (task.allOfficerComments) {
        try {
          const commentsArray = JSON.parse(task.allOfficerComments);
          if (Array.isArray(commentsArray) && commentsArray.length > 0) {
            officerCommentsHtml = commentsArray.map((commentObj) => {
              const createdByName = commentObj.createdByName || commentObj.commentBy || 'Officer';
              const commentDate = commentObj.commentDate || commentObj.createdDate;
              const formattedDate = formatDateTime(commentDate);
              const commentText = commentObj.commentText || commentObj.comment || '';

              processedOfficerComments.add(commentText.trim().toLowerCase());

              if (!latestAdditionalCommentBy) {
                latestAdditionalCommentBy = createdByName;
                latestAdditionalCommentDate = formattedDate;
              }

              return `
                <div class="officer-update" style="margin-bottom: 12px;">
                  <strong style="color: dodgerblue;">Officer Responsible (Last Updated: ${formatDate(task.latestCommentDate) || 'N/A'})</strong><br>
                  <strong>${createdByName} : ${formattedDate}</strong><br>
                  <span>${commentText}</span>
                </div>
              `;
            }).join('');
          }
        } catch (err) {
          console.error("Error parsing allOfficerComments for task", task.taskID, err);
        }
      }
      

      if (!officerCommentsHtml && task.officerComments && task.officerComments !== 'N/A') {
        const commentsArray = task.officerComments
          .split(',')
          .map(comment => comment.trim())
          .filter(comment => comment !== '');

        const commentDates = Array.isArray(task.officerCommentDates)
          ? task.officerCommentDates
          : (typeof task.officerCommentDates === 'string' 
              ? task.officerCommentDates.split(',').map(date => date.trim()) 
              : []);

        if (commentsArray.length > 0) {
          officerCommentsHtml = commentsArray.map((comment, i) => {
            const separatorIndex = comment.indexOf(':');
            const officerName = separatorIndex !== -1 ? comment.substring(0, separatorIndex).trim() : 'Officer';
            const commentText = separatorIndex !== -1 ? comment.substring(separatorIndex + 1).trim() : comment;
            const commentDate = formatDate(commentDates[i]) || 'N/A';
          
            processedOfficerComments.add(commentText.trim().toLowerCase());

            if (!latestAdditionalCommentBy) {
              latestAdditionalCommentBy = officerName;
              latestAdditionalCommentDate = commentDate;
            }

            return `
              <div class="officer-update" style="margin-bottom: 12px;">
                <strong style="color: dodgerblue;">Officer Responsible (Last Updated: ${formatDate(task.latestCommentDate) || 'N/A'})</strong><br>
                <strong>${officerName} : ${commentDate}</strong><br>
                <span>${commentText}</span>
              </div>
            `;
          }).join('');
        }
      }

      if (!latestAdditionalCommentBy && (task.officerNames || task.officerResponsible)) {
        latestAdditionalCommentBy = task.officerNames || task.officerResponsible;
        latestAdditionalCommentDate = formatDateTime(task.latestCommentDate) || 'N/A';
      }

      let additionalCommentsHtml = '';
      if (task.additionalComments && 
          task.additionalComments !== 'N/A' && 
          !processedOfficerComments.has(task.additionalComments.trim().toLowerCase())) {
        
        const additionalCommentBy = latestAdditionalCommentBy || task.officerNames || task.officerResponsible || 'Officer';
        const additionalCommentDate = latestAdditionalCommentDate || formatDateTime(task.latestCommentDate) || formatDate(task.latestCommentDate) || 'N/A';
        
        additionalCommentsHtml = `
          <div class="additional-comments" style="margin-bottom: 12px;">
            <strong style="color: dodgerblue;">Officer Responsible (Last Updated: ${formatDate(task.latestCommentDate) || 'N/A'})</strong><br>
            <strong>${additionalCommentBy} : ${additionalCommentDate}</strong><br>
            <span>${task.additionalComments}</span>
          </div>
        `;
      }


      if (!officerCommentsHtml && task.additionalComments && task.additionalComments !== 'N/A') {
        const fallbackOfficer = task.officerNames || task.officerResponsible || 'Officer';
        const fallbackDate = formatDateTime(task.latestCommentDate) || formatDate(task.latestCommentDate) || 'N/A';
        
        officerCommentsHtml = `
          <div class="officer-update" style="margin-bottom: 12px;">
            <strong style="color: dodgerblue;">Officer Responsible (Last Updated: ${formatDate(task.latestCommentDate) || 'N/A'})</strong><br>
            <strong>${fallbackOfficer} : ${fallbackDate}</strong><br>
            <span>${task.additionalComments}</span>
          </div>
        `;
        additionalCommentsHtml = '';
      }


      console.log(`Task ${task.taskID} final HTML:`, {
        actionStatusHistoryHtml: !!actionStatusHistoryHtml,
        officerCommentsHtml: !!officerCommentsHtml,
        additionalCommentsHtml: !!additionalCommentsHtml
      });

      return `
        <tr>
          <td>${attachmentIcon} ${currentSerial}</td>
          <td>${formatValue(task.taskID)}</td>
          <td>${formatValue(task.issueActionOrDecision)}</td>
          <td>${formatValue(task.officerNames || task.officerResponsible)}</td>
          <td>
            Date of decision/initiation: ${formatDate(task.dateOfDecisionOrInitiation) || ''}<br>
                  Deadline: <br> ${
        task.deadline ? formatDate(task.deadline) + ' *' : ''
      }${
        task.allDeadline 
          ? '<br>' + 
            [...new Set(
              task.allDeadline
                .split(',')
                .map(d => d.trim())
                .filter(d => {
                  if (d === task.deadline) return false;
                  return formatDate(d) !== formatDate(task.deadline);
                })
                .reverse()
            )]
            .map(d => formatDate(d))
            .join('<br>')
          : ''
      }<br>
            <br><span class="status-completed">Status: ${formatValue(task.status)}</span><br>
          </td>
          <td>
            ${actionStatusHistoryHtml}
            ${officerCommentsHtml}
            ${additionalCommentsHtml}
          </td>
        </tr>
      `;
    }).join('');

    return `
      <div class="section">
        <div class="info-row">
          <div class="task-coordinator">Task Coordinator: ${formatValue(coordinator)}</div>
          <div class="priority">Priority: ${formatValue(priority)}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width: 5%">S.r.No.</th>
              <th style="width: 8%">Task ID</th>
              <th style="width: 22%">Issue.Action or Decision</th>
              <th style="width: 15%">Officer Responsible</th>
              <th style="width: 20%">Timelines</th>
              <th style="width: 30%">Action Taken/Status</th>
            </tr>
          </thead>
          <tbody>
            ${tasksHtml}
          </tbody>
        </table>
      </div>
    `;
  }).join('');

  const formattedDate = format(currentDate, 'dd/MM/yyyy hh:mm:ss a');

  const reportContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>TaskTracking Dashboard Report</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
        <style>
            @page {
                size: A4;
                margin: 20mm;
            }

            body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
                line-height: 1.5;
                font-size: 11pt;
                color: #333;
                background-color: #fff;
            }

            .page-container {
                width: 80%;
                margin: 0 auto;
                padding: 10mm 0;
                box-sizing: border-box;
            }

            @media print {
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                    background: white;
                }
                .page-container {
                    width: 80%;
                    padding: 0;
                    margin: 0 auto;
                }
            }

            .header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
            }

            .title {
                width: 100%;
                text-align: center;
                font-size: 20pt;
                color: #2c3e50;
                font-weight: bold;
                margin: 5px 0 15px 0;
            }

            .report-date {
                font-size: 10pt;
                color: #555;
                text-align: right;
                margin-bottom: 15px;
            }

            .info-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 5px 0 10px 0;
            }

            .task-coordinator {
                font-size: 12pt;
                color: #2c3e50;
            }

            .priority {
                font-weight: bold;
                font-size: 11pt;
                color: #c0392b;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                margin: 10px 0 20px 0;
                page-break-inside: avoid;
                font-size: 10pt;
            }

            th, td {
                border: 1px solid #ddd;
                padding: 6px 8px;
                text-align: left;
                vertical-align: top;
            }

            th {
                background-color: #f2f2f2;
                font-weight: bold;
            }

            .status-completed {
                color: #155724;
                background-color: #d4edda;
                padding: 2px 6px;
                border-radius: 3px;
                font-weight: bold;
                display: inline-block;
                font-size: 9pt;
            }
            
            .status-delay {
                color: #856404;
                background-color: #fff3cd;
                padding: 2px 6px;
                border-radius: 3px;
                font-weight: bold;
                display: inline-block;
                font-size: 9pt;
            }
            
            .status-significant-delay {
                color: #721c24;
                background-color: #f8d7da;
                padding: 2px 6px;
                border-radius: 3px;
                font-weight: bold;
                display: inline-block;
                font-size: 9pt;
            }

            .section {
                page-break-inside: avoid;
                margin-bottom: 25px;
            }
            
            .highlight-task-coordinator {
                color: red;
                font-weight: bold;
                font-size: 9pt;
            }
            
            .highlight-officer-responsible {
                color: blue;
                font-weight: bold;
                font-size: 9pt;
            }
            
            tr {
                page-break-inside: avoid;
            }
            
            .attachment-icon {
                color: #666;
                margin-right: 5px;
            }
            
            .action-history, .officer-update, .additional-comments {
                margin-top: 8px;
                font-size: 9pt;
                border-top: 1px dashed #ccc;
                padding-top: 8px;
            }
            
            .action-history strong, .officer-update strong, .additional-comments strong {
                color: #2c3e50;
            }
        </style>
    </head>
    <body>
        <div class="page-container">
            <div class="report-date">Date Time: ${formattedDate}</div>
            <div class="title">TaskTracking Dashboard Report</div>
            
            ${sections}
        </div>
    </body>
    </html>
  `;

  const reportWindow = window.open('', '_blank');
  reportWindow.document.open();
  reportWindow.document.write(reportContent);
  reportWindow.document.close();
};// Report With ALL Comments

  return (
    <div className="container mt-4 mb-4 px-0">
     <div className="tabs-section-wrapper mb-2">
          <div className='row '>
 <div className="d-flex  justify-content-lg-center  tabs-section gap-3 mb-2">
    <Link to="/dashboard/reports">
      <Button variant="btn-primary" className="btn-tab">Task Detail</Button>
    </Link>
{(isAdmin || !isRestrictedUser) && (
  <>
    <Link to="/dashboard/UserLoginHistory">
      <Button variant="light" className="btn-tab btn-btn-sechover">User Login History</Button>
    </Link>
    <Link to="/dashboard/UserTaskUpdate">
      <Button variant="light" className="btn-tab btn-btn-sechover">User Task Update</Button>
    </Link>
    <Link to="/dashboard/UserFrequency">
      <Button variant="light" className="btn-tab btn-btn-sechover">User Frequency</Button>
    </Link>
  </>
)}

    <Link to="/dashboard/voiceSearch">
      <Button variant="light" className="btn-tab">VoiceSearch</Button>
    </Link>
  </div>
  </div>
</div>


      <div className='row custombox'>
        <div className='rounded p-4 mb-4'>
          <div className="text-center customheader">
            <h5 className="mb-0 page-heading">Task Detail</h5>
          </div>

        
            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Task ID</Form.Label>
                <Select
                  options={taskIdOptions}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('taskId', selected)}
                  value={filters.taskId}
                  placeholder="Select Task ID"
                  isClearable
                  isSearchable
                />
              </Col>

              <Col md={8}>
                <Form.Label>Issue, Action or Decision</Form.Label>
                <Form.Control
                  name="issueActionOrDecision"
                  value={filters.issueActionOrDecision}
                  onChange={handleInputChange}
                  placeholder="Issue, Action or Decision"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Group</Form.Label>
                <Select
                  options={groups}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('group', selected)}
                  value={filters.group}
                  placeholder="Select Group"
                  isClearable
                  isSearchable
                />
              </Col>
              <Col md={8}>
                <Form.Label>Task Coordinator</Form.Label>
                <Select
                  options={taskCoordinators}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('taskCoordinator', selected)}
                  value={filters.taskCoordinator}
                  placeholder="Select Task Coordinator"
                  isClearable
                  isSearchable
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Followed By</Form.Label>
                <Select
                  options={allUsers.map(user => ({
                    value: user.userID,
                    label: `${user.username} (${user.roleName})`
                  }))}
                  isLoading={isLoading}
                  onChange={handleFollowedByChange}
                  value={filters.followedBy}
                  placeholder="Select Followed By"
                  isClearable
                  isSearchable
                />
              </Col>

              <Col md={8}>
                <Form.Label>Officer Responsible</Form.Label>
                <Select
                  options={officerOptions}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('officerResponsible', selected)}
                  value={filters.officerResponsible}
                  placeholder="Select Officer"
                  isClearable
                  isSearchable
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Priority</Form.Label>
                <Select
                  options={priorityOptions}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('priority', selected)}
                  value={filters.priority}
                  placeholder="Select Priority"
                  isClearable
                  isSearchable
                />
              </Col>
              <Col md={4}>
                <Form.Label>Status</Form.Label>
                <Select
                  options={statusOptions}
                  isLoading={isLoading}
                  onChange={(selected) => handleSelectChange('status', selected)}
                  value={filters.status}
                  placeholder="Select Status"
                  isClearable
                  isSearchable
                />
              </Col>
              <Col md={4}>
                <Form.Label>Category</Form.Label>
                <Select
                  options={categoryOptions}
                  onChange={(selected) => handleSelectChange('category', selected)}
                  value={filters.category}
                  placeholder="Select Category"
                  isClearable
                  isSearchable
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Date of Decision</Form.Label>
                <InputGroup className="mb-2">
                  <DatePicker
                    selected={decisionFrom}
                    onChange={(date) => setDecisionFrom(date)}
                    className="form-control"
                    placeholderText="From"
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                    ref={decisionFromRef}
                  />
                  <InputGroup.Text
                    onClick={() => decisionFromRef.current?.setFocus()}
                    style={{ cursor: 'pointer' }}
                  >
                    <BsCalendar />
                  </InputGroup.Text>
                </InputGroup>
              </Col>

              <Col md={3}>
                <Form.Label>&nbsp;</Form.Label>
                <InputGroup>
                  <DatePicker
                    selected={decisionTo}
                    onChange={(date) => setDecisionTo(date)}
                    className="form-control"
                    placeholderText="To"
                    dateFormat="dd-MM-yyyy"
                    ref={decisionToRef}
                  />
                  <InputGroup.Text
                    onClick={() => decisionToRef.current?.setFocus()}
                    style={{ cursor: 'pointer' }}
                  >
                    <BsCalendar />
                  </InputGroup.Text>
                </InputGroup>
              </Col>

              <Col md={3}>
                <Form.Label>Deadline</Form.Label>
                <InputGroup className="mb-2">
                  <DatePicker
                    selected={deadlineFrom}
                    onChange={(date) => setDeadlineFrom(date)}
                    className="form-control"
                    placeholderText="From"
                    dateFormat="dd-MM-yyyy"
                    ref={deadlineFromRef}
                  />
                  <InputGroup.Text
                    onClick={() => deadlineFromRef.current?.setFocus()}
                    style={{ cursor: 'pointer' }}
                  >
                    <BsCalendar />
                  </InputGroup.Text>
                </InputGroup>
              </Col>

              <Col md={3}>
                <Form.Label>&nbsp;</Form.Label>
                <InputGroup>
                  <DatePicker
                    selected={deadlineTo}
                    onChange={(date) => setDeadlineTo(date)}
                    className="form-control"
                    placeholderText="To"
                    dateFormat="dd-MM-yyyy"
                    ref={deadlineToRef}
                  />
                  <InputGroup.Text
                    onClick={() => deadlineToRef.current?.setFocus()}
                    style={{ cursor: 'pointer' }}
                  >
                    <BsCalendar />
                  </InputGroup.Text>
                </InputGroup>
              </Col>
            </Row>

            <Row className="mb-3 justify-content-center">
              <Col md={4} className="d-flex justify-content-center align-items-center">
                <Form.Check
                  type="checkbox"
                  id="attachmentsOnly"
                  label="Attachments only"
                  name="attachmentsOnly"
                  checked={filters.attachmentsOnly}
                  onChange={(e) => handleInputChange({
                    target: {
                      name: 'attachmentsOnly',
                      type: 'checkbox',
                      checked: e.target.checked
                    }
                  })}
                />
              </Col>
            </Row>

            <div className="text-center mt-4">
              <Button
                variant="btn-primary"
               
                className="px-4 me-3 btn-fontweight"
                onClick={handleSearch}
             
              >
                {isLoading ? 'Searching...' : 'Search'}
              </Button>
              <Button
                variant="secondary"
                className="px-4  btn-fontweight"
                onClick={handleClear}
          
              >
                Clear
              </Button>
            </div>
        
        </div>
      </div>
{hasSearched && (
    <div className="container mt-4 mb-4">
          <Row>
  <div className="tabs-section-wrapper mb-2">
        <div className='row'>
 <div className="d-flex  d-block tabs-section gap-3 mb-2">

<Button  className="me-2 btn-fontweight custompdf-btn  btn-tab2"  onClick={openReport} > Report</Button>

      <Button 
 
        onClick={handleExportToExcel}
         className='btn-fontweight customexport-btn me-2 btn-tab2'
        disabled={tasks.length === 0}
      >
        Export to Excel
      </Button>

      <Button 
      className='btn-fontweight customexport-btn btn-tab'
        onClick={handleReportWithAllComments}
        disabled={tasks.length === 0}
      >
        Report With All Comments
      </Button>
    </div>
  </div>
    </div>
  <div className="card shadow-sm rounded-4 py-4 px-0  border-0 bg-white mb-custom">
    <DataTable
    columns={columns}
    data={tasks.map((dept, idx) => ({
    ...dept,
    _rowIndex: idx, 
  }))}
       pagination
      progressPending={isLoading}
      noHeader={false}
      fixedHeader
      fixedHeaderScrollHeight="calc(100vh - 0px)"
      className="p-datatable-striped customuser-data-table customarchive-data-table   dashboard-table"
      customStyles={{
              table: {
                style: {
             
      fontWeight: '600',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
      textAlign: 'center',
                },
              },
              headRow: {
                style: {
                  backgroundColor: "#04364A!important",
                  minHeight: "48px",
                },
              },
              headCells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "white",
                  textTransform: "uppercase",
                  
                    textAlign: "center", 
        justifyContent: "center",
                },
              },
           
              cells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "14px",
                  color: "#334155",
                },
              },
            }}
      conditionalRowStyles={[
     {
    when: (row) => row._rowIndex % 2 === 0, 
    style: { backgroundColor: '#f2f2f2' },
  },
  {
    when: (row) => row._rowIndex % 2 !== 0,
    style: { backgroundColor: '#ffffff' },
  },
  ]}      
     
      noDataComponent={<div className="py-4">No tasks found.</div>}
    />
  </div>
  </Row>
</div>
)}

      <DeadlineHistoryModal
        show={deadlineHistoryModal.visible}
        onHide={() => setDeadlineHistoryModal(prev => ({ ...prev, visible: false }))}
        deadlines={deadlineHistoryModal.deadlines}
        loading={deadlineHistoryModal.loading}
        taskId={deadlineHistoryModal.currentTaskId}
      />

      <AttachmentsModal
        show={attachmentsModal.show}
        onHide={() => setAttachmentsModal(prev => ({ ...prev, show: false }))}
        taskId={attachmentsModal.taskId}
        officerNames={attachmentsModal.officerNames}
        onFileDelete={attachmentsModal.onFileDelete}
      />

      <CommentsModal
        show={commentsModal.show}
        onHide={() => setCommentsModal(prev => ({ ...prev, show: false }))}
        taskId={commentsModal.taskId}
        type={commentsModal.type}
        officerNames={commentsModal.officerNames}
        coordinatorName={commentsModal.coordinatorName}
      />
    </div>
  );
};

export default TaskDetailForm;